module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/landprocurement/rate-fixation/rate-grid/rate-grid.component.css
// module id = ./src/app/landprocurement/rate-fixation/rate-grid/rate-grid.component.css
// module chunks = main